import type { ComponentProps } from 'react'
import type RealisticConfetti from 'react-canvas-confetti/dist/presets/realistic'

export const CONFETTI_COLOURS: Record<App.LoyaltyTier, Array<string>> = {
  bronze: ['#EFE7E3', '#D4B5A4', '#91674E'],
  silver: ['#E7E8EA', '#BABCC2', '#6D717C'],
  gold: ['#EFE8D1', '#C6BC92', '#78704E'],
  platinum: ['#F4F4F5', '#D4D4D8', '#A1A1AA', '#71717A'],
  infinite: ['#FFEED6', '#FAD9BF', '#D9AB91', '#A7806C'],
}

export const CONFETTI_AUTO_RUN: NonNullable<ComponentProps<typeof RealisticConfetti>['autorun']> = {
  duration: 5,
  delay: 1,
  speed: 1,
}
